export const GRID_CONFIG = {
  spacing: 16, // Gap between items (in pixels)
  mobileSpacing: 8, // Gap between items on mobile (in pixels)
  breakpoints: {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536
  },
  content: {
    video: {
      aspectRatio: 16 / 9,
      columns: {
        xs: 1,
        sm: 2,
        md: 3,
        lg: 4,
        xl: 4,
        '2xl': 5
      },
      minWidth: 220, // Reduced from 240 for mobile
      maxWidth: 400
    },
    shorts: {
      aspectRatio: 9 / 16,
      columns: {
        xs: 2,
        sm: 3,
        md: 4,
        lg: 5,
        xl: 6,
        '2xl': 7
      },
      minWidth: 120, // Reduced from 140 for mobile
      maxWidth: 240
    }
  }
} as const; 